"use client";
import { IUserData, IUsersBrandAccounts } from "@/types";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { SetDisplayName } from "@/lib/api";
import * as Impersonate from "@/lib/impersonate_api";
import React from "react";
import { toast } from "sonner";

interface Props {
    user: IUserData;
    updateUser: IUserData;
    setUpdateUser: React.Dispatch<React.SetStateAction<IUserData>>;
    admin?: boolean;
    className?: string;
    impersonate?: boolean;
    ws?: WebSocket | null;
    loggedInUser?: IUsersBrandAccounts | undefined;
}

export default function DisplayName({
    user,
    updateUser,
    setUpdateUser,
    admin,
    className,
    impersonate,
    ws,
    loggedInUser,
}: Props) {
    const [displayName, setDisplayName] = React.useState(
        updateUser.displayname
    );
    const onDisplayNameBlur = async () => {
        if (user.displayname === updateUser.displayname) return;
        const toastid = toast("Updating Display name...");
        if (impersonate && ws && loggedInUser?.role !== "user") {
            ws.send(
                JSON.stringify({
                    type: "update_header",
                    data: {
                        pic: updateUser.pic,
                        displayname: updateUser.displayname,
                        bio: updateUser.bio,
                        pronouns: updateUser.settings.pronouns,
                        location: updateUser.settings.location,
                        layout: updateUser.theme.layout,
                        design: updateUser.design,
                    },
                })
            );
        }
        let response: any;
        if (impersonate) {
            response = await Impersonate.SetDisplayName(
                user,
                updateUser.displayname
            );
        } else {
            response = await SetDisplayName(user, updateUser.displayname);
        }
        response = await response.json();
        if (!response.error) {
            // Update the user object directly
            user.displayname = updateUser.displayname;
            toast.success("Display name updated", { id: toastid });
        } else {
            toast.error(
                "Something went wrong, refresh and try again. If the issue persists, please log out and log back in",
                {
                    description: JSON.stringify(response),
                    id: toastid,
                }
            );
        }
    };
    return (
        <>
            {admin ? (
                <div className="flex items-end gap-1">
                    <Input
                        label="Display name"
                        variant="card"
                        className="w-full"
                        value={displayName}
                        onChange={(e) => {
                            setDisplayName(e.target.value);
                            setUpdateUser({
                                ...updateUser,
                                displayname: e.target.value,
                            });
                        }}
                        onBlur={onDisplayNameBlur}
                    />
                </div>
            ) : updateUser.displayname === "" ? (
                <Label variant="toggle" className={`${!admin && "hidden"}`}>
                    No display name set
                </Label>
            ) : (
                <p
                    className={`w-fit text-xl font-bold ${className}`}
                    id={"display-name"}
                >
                    {updateUser.displayname}
                </p>
            )}
        </>
    );
}
